// extracted by mini-css-extract-plugin
export default {"container":"BurgerContains_container__Q-Shi","list":"BurgerContains_list__DYIHo"};